(ns frontend.test.lp-portal.modals.chart-editor.event
  (:require
   [common.time :as c-time]
   [frontend.test.lp-portal.modals.chart-editor.sub :as sub]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::save-dynamic-data
 (fn [{db :db} [_ path value]]
   (let [new-db (assoc-in db (concat [::sub/dynamic-data] path) value)
         new-db (if (not= (last path) :manual-data)
                  new-db
                  (-> new-db
                      (assoc-in (concat [::sub/dynamic-data]
                                        (butlast path)
                                        [:manual-data-by])
                                12034)
                      (assoc-in (concat [::sub/dynamic-data]
                                        (butlast path)
                                        [:manual-data-on])
                                (c-time/now-millis))))]
     {:db new-db})))
